import * as css from './AccountMenuIcon.css';

function AccountMenuIcon({text, icon, hasArrow, dataCy, onClick}) {
    return (
        <css.item onClick={onClick} data-cy={`account-menu-${dataCy}`}>
            <css.circle $icon={icon}/>
            <css.label>{text}{hasArrow && <css.arrow/>}</css.label>
        </css.item>
    );
}

export default AccountMenuIcon;
